import { type AdapterConfigStatus } from "../hooks/use-shell-connection";

export function getAdapterConfigStatusLabel(
  status: AdapterConfigStatus | null,
): string {
  if (!status) {
    return "Adapter config: waiting for publish.";
  }

  if (status.state === "publishing") {
    return `Adapter config: publishing ${status.platform}@${status.version}...`;
  }

  if (status.state === "applied") {
    return `Adapter config: applied ${status.platform}@${status.version}.`;
  }

  if (status.state === "rejected") {
    return (
      status.detail ??
      `Adapter config: rejected ${status.platform}@${status.version}; shell fallback remains active.`
    );
  }

  return (
    status.detail ??
    `Adapter config: publish failed for ${status.platform}@${status.version}; shell fallback remains active.`
  );
}

